var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12.1674 8 12.3294 8.03053 12.4859 8.0916C12.6433 8.15267 12.7743 8.2341 12.8789 8.33588L18.6547 13.9542C18.8849 14.1781 19 14.4631 19 14.8092C19 15.1552 18.8849 15.4402 18.6547 15.6641C18.4245 15.888 18.1315 16 17.7758 16C17.42 16 17.1271 15.888 16.8969 15.6641L12 10.9008L7.10314 15.6641C6.87295 15.888 6.57997 16 6.22422 16C5.86846 16 5.57549 15.888 5.34529 15.6641C5.1151 15.4402 5 15.1552 5 14.8092C5 14.4631 5.1151 14.1781 5.34529 13.9542L11.1211 8.33588C11.2466 8.21374 11.3827 8.12743 11.5291 8.07695C11.6756 8.02565 11.8326 8 12 8Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.8c3e3361.svg";
export { ForwardRef as ReactComponent };